import React from "react";
import NumberKeyboard from "../common/numberKeyboard";

const formatPhone = (value = "") => {
  const onlyNum = String(value).replace(/\D/g, "");

  if (onlyNum.length <= 3) return onlyNum;
  if (onlyNum.length <= 7) return `${onlyNum.slice(0, 3)}-${onlyNum.slice(3)}`;
  return `${onlyNum.slice(0, 3)}-${onlyNum.slice(3, 7)}-${onlyNum.slice(7, 11)}`;
};

const ReserveInput = ({ transformValue, formData, handleChangeInput, determineStepAction }) => {
  return (
    <div className="slideContent" style={{ transform: `translateX(${transformValue}%)` }}>
      <div className="inputBox">
        <div className="inputFields">
          <input
            type="text"
            value={formatPhone(formData.tel)}
            readOnly
            placeholder="010-0000-0000"
          />
        </div>

        <div className="keyboardFields">
          <NumberKeyboard
            type="tel"
            handleChangeInput={handleChangeInput}
            inputValue={formData.tel}
          />
        </div>

        <div className="inputActions">
          <button type="button" onClick={() => determineStepAction(true)}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReserveInput;